import { render } from "./openVip.vue?vue&type=template&id=d880dca4&scoped=true"
import script from "./openVip.vue?vue&type=script&lang=js"
export * from "./openVip.vue?vue&type=script&lang=js"

import "./openVip.vue?vue&type=style&index=0&id=d880dca4&scoped=true&lang=css"

import exportComponent from "D:\\Program Files\\vueProject\\sys-bg-sjyy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d880dca4"]])

export default __exports__